type Props = {
  checked: boolean;
  onChange: (next: boolean) => void;
  className?: string;
};

export default function ActivePlayersOnlyCheckbox({ checked, onChange, className = '' }: Props) {
  return (
    <label
      className={`inline-flex h-10 cursor-pointer items-center gap-2 rounded-lg border px-3 text-sm font-medium leading-none ${
        checked
          ? 'border-emerald-200 bg-emerald-50 text-emerald-900'
          : 'border-stone-200 bg-white text-stone-600'
      } ${className}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 rounded border-stone-300 text-emerald-600 focus:ring-emerald-500"
      />
      Active Players only
    </label>
  );
}
